interface BrandPageContext {
  readonly onBrand: true
  readonly brand: string
  readonly onHost: false
  readonly onCrossBrand: false
}
export const createBrandPageContext = (brand: string): BrandPageContext => ({
  brand,
  onBrand: true,
  onHost: false,
  onCrossBrand: false ,
})

/**
 * SINGLEインスタンス時は、ホストと呼ばれるページ（マイページなど）も単一ブランド配下と観念しうる。
 * しかし今のところは、SINGLEインスタンスかどうかは別途InstanceResolver等を通じて判定しその単一ブランドを取得することにし、
 * SINGLE/MULTIインスタンスの違いはこのHost/Brandページの概念の違いには影響しないものとする。
 * 将来的には、SINGLE/MULTIの違いと、Host/Brandの違いを集約したコンテキストを作るなど検討する。
 * @see https://github.com/my-color/growthpalette-front/pull/7681#discussion_r1381921134
 */
interface HostPageContext {
  readonly onBrand: false
  readonly brand: null
  readonly onHost: true
  readonly onCrossBrand: false
}
export const hostPageContext: HostPageContext = {
  brand: null,
  onBrand: false,
  onHost: true,
  onCrossBrand: false,
}

interface CrossBrandPageContext {
  readonly onBrand: false
  readonly brand: null
  readonly onHost: false
  readonly onCrossBrand: true
}
export const crossBrandPageContext: CrossBrandPageContext = {
  brand: null,
  onBrand: false,
  onHost: false,
  onCrossBrand: true,
}

type PageContext = BrandPageContext | HostPageContext | CrossBrandPageContext

export interface WithPageContext {
  readonly page: PageContext
}
